<template>
  <teleport to="body">
    <div class="debug-modal-backdrop" @click.self="$emit('close')">
      <div class="modal-content" :style="{ width: modalWidth, maxWidth: '95vw' }">
        <div class="modal-header">
          <h3 class="modal-title">{{ $t('anadir_incidencia') }}</h3>
          <button type="button" class="btn-close" @click.stop="cerrar" aria-label="Cerrar" title="Cerrar">
            <span class="material-icons action-icon">close</span>
          </button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="handleSubmit($event)" @keydown.enter.prevent>
            <!-- Select de Usuario (primero): quien tiene la incidencia. Visible para roles != 4 -->
            <div class="form-group" v-if="Number(userRole) !== 4">
              <label for="usuario_id" class="form-label">{{ $t('usuario') }}</label>
              <select id="usuario_id" v-model="form.usuario_id" class="form-control">
                <option v-for="u in users" :key="u.id" :value="u.id">{{ u.nombre }}</option>
              </select>
              
            </div>
            <div class="form-group">
              <label for="categoria" class="form-label">{{ $t('categoria') }}</label>
              <select id="categoria" v-model="form.categoria" class="form-control" required>
                <option value="" disabled>{{ $t('seleccione_categoria') }}</option>
                <option v-for="categoria in categorias" :key="categoria.id" :value="categoria.id">
                  {{ getCategoriaTraducida(categoria.nombre) }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="prioridad" class="form-label">{{ $t('prioridad') }}</label>
              <select id="prioridad" v-model="form.prioridad" class="form-control" required>
                <option value="" disabled>{{ $t('seleccione_prioridad') }}</option>
                <option v-for="prioridad in prioridades" :key="prioridad.id" :value="prioridad.id">
                  {{ $t('nivel_' + prioridad.nombre.toLowerCase()) }}
                </option>
              </select>
            </div>

            

            <div class="form-group">
              <label for="descripcion" class="form-label">{{ $t('descripcion') }}</label>
              <textarea
                id="descripcion"
                v-model="form.descripcion"
                class="form-control"
                required
                :maxlength="maxDescripcion"
                @input="onDescripcionInput"
              ></textarea>
              <div class="text-muted small" style="text-align: right; margin-top:6px;">
                {{ (maxDescripcion - (form.descripcion ? form.descripcion.length : 0)) }} {{ $t('caracteres_restantes') || 'caracteres restantes' }}
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">{{ $t('archivos_adjuntos') }}</label>
              <input
                id="archivos"
                type="file"
                multiple
                accept=".pdf,image/*"
                style="display: none;"
                ref="fileInput"
                @change="addFiles"
              />
              <button
                type="button"
                class="btn btn-elegir-archivo"
                :disabled="isReadOnly"
                @click="!isReadOnly && $refs.fileInput.click()"
              >
                {{ $t('elegir_archivos') }}
              </button>
            </div>

            <div v-if="selectedFiles.length" class="form-group">
              <label class="form-label">{{ $t('archivos_seleccionados') }}</label>
              <div class="adjuntos-scroll">
                <ul style="list-style:none; padding:0; margin:0;">
                  <li v-for="(file, idx) in selectedFiles" :key="idx" style="display:flex; align-items:center; border-bottom:1px solid #eee; padding:6px 0;">
                    <div style="flex:1 0 120px; min-width:120px;">
                      <template v-if="renameIndex === idx">
                        <input v-model="renameBase" style="width: 120px;" type="text" :placeholder="getBaseName(file.name)" autofocus />
                        .{{ getExtension(file.name) }}
                        <button type="button" @click="confirmRename(idx)" style="background:none; border:none; cursor:pointer; margin-left:3px;" :title="$t('confirmar_nombre')">
                          <span class="material-icons action-icon">check_circle</span>
                        </button>
                        <button type="button" @click="cancelRenameEdit" style="background:none; border:none; cursor:pointer; margin-left:3px;" :title="$t('cancelar_edicion')">
                          <span class="material-icons action-icon">close</span>
                        </button>
                      </template>
                      <template v-else>
                        {{ file.name }}
                      </template>
                    </div>

                    <div style="flex:2 1 0; min-width:160px; max-width:100%;">
                      <span v-if="commentIndex === idx">
                        <input v-model="commentValue" style="width: 90%;" type="text" :placeholder="$t('comentario_opcional')" autofocus />
                        <button type="button" @click="confirmComment(idx)" style="background:none; border:none; cursor:pointer; margin-left:3px;" :title="$t('confirmar_comentario')">
                          <span class="material-icons action-icon">check_circle</span>
                        </button>
                        <button type="button" @click="cancelCommentEdit" style="background:none; border:none; cursor:pointer; margin-left:3px;" :title="$t('cancelar_edicion')">
                          <span class="material-icons action-icon">close</span>
                        </button>
                      </span>
                      <span v-else>
                        <span v-if="file.comentario">{{ file.comentario.length > 40 ? file.comentario.slice(0, 40) + '...' : file.comentario }}</span>
                        <a v-if="file.comentario && file.comentario.length > 40 && expandedComment !== idx" href="#" @click.prevent="expandedComment = idx" style="color:#99172A; margin-left:5px;">{{ $t('ver_mas') }}</a>
                        <template v-if="expandedComment === idx">
                          {{ file.comentario }}
                          <a href="#" @click.prevent="expandedComment = null" style="color:#99172A; margin-left:5px;">{{ $t('ver_menos') }}</a>
                        </template>
                      </span>
                    </div>

                    <div style="display:flex; gap:2px; min-width:120px; justify-content:flex-end;">
                      <!-- Botón de previsualizar -->
                      <button type="button" class="btn-preview" :title="$t('previsualizar')" @click="previewFile(file)">
                        <span class="material-icons action-icon" style="font-size:18px;">visibility</span>
                      </button>
                      <button type="button" @click="startRename(idx)" style="background:none; border:none; cursor:pointer;" :title="$t('renombrar')">
                        <span class="material-icons action-icon">edit_square</span>
                      </button>
                      <button type="button" @click="toggleComment(idx)" style="background:none; border:none; cursor:pointer;" :title="file.comentario ? $t('editar_comentario') : $t('anadir_comentario')">
                        <span class="material-icons action-icon">comment</span>
                      </button>
                      <button type="button" @click="downloadFile(file)" style="background:none; border:none; cursor:pointer;" :title="$t('descargar_archivo')">
                        <span class="material-icons action-icon">download</span>
                      </button>
                      <button type="button" @click="removeFile(idx)" style="background:none; border:none; cursor:pointer;" :title="$t('eliminar')">
                        <span class="material-icons action-icon">delete</span>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div v-if="ticketFiles.length" class="form-group">
              <label class="form-label">{{ $t('archivos_ya_subidos') }}</label>
              <ul>
                <li v-for="file in ticketFiles" :key="file.id">
                  <a :href="getDownloadUrl(file.id)" target="_blank">{{ file.filename }}</a>
                </li>
              </ul>
            </div>

            <div class="form-actions">
              <button type="submit" class="btn btn-primary" :disabled="isSaving">
                <span v-if="isSaving">{{ $t('guardando') }}…</span>
                <span v-else>{{ $t('guardar') }}</span>
              </button>
              <button type="button" class="btn-cancel" @click.stop="cerrar">Cancelar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>

  <!-- PreviewModal -->
  <PreviewModal
    v-if="previewVisible"
    :visible="previewVisible"
    :file="previewFileObj"
    :previewUrl="previewObjectUrl"
    @close="closePreview"
    @download="handlePreviewDownload"
  />
</template>

<script>
import api from '../api';
import { showAlert } from '@/utils/alerts';
import Swal from 'sweetalert2';
import PreviewModal from '@/components/PreviewModal.vue';

export default {
  name: 'TicketFormModalView',
  components: { PreviewModal },
  emits: ['close','submit'],
  data() {
    return {
  form: { categoria: '', prioridad: 1, descripcion: '', estado: 1, usuario_id: null, usuario_asignado_id: null },
      categorias: [],
      estados: [],
  users: [],
  userRole: null,
      prioridades: [
        { id: 1, nombre: 'Baja' },
        { id: 2, nombre: 'Media' },
        { id: 3, nombre: 'Alta' },
      ],
      selectedFiles: [],
      ticketFiles: [],
      // Estado de previsualización
      previewVisible: false,
      previewFileObj: null,        // Objeto que se pasa a PreviewModal
      previewObjectUrl: '',        // URL temporal para archivos locales
      renameIndex: null,
      renameBase: '',
      commentIndex: null,
      commentValue: '',
      expandedComment: null,
      isSaving: false,
      uploadProgress: 0,
      maxDescripcion: 1500,
    };
  },
  computed: {
    modalWidth() {
      const minWidth = window.innerWidth * 0.4;
      const maxWidth = window.innerWidth * 0.95;
      
      const width = this.selectedFiles.length > 0 ? 
        Math.min(maxWidth, Math.max(minWidth, 800)) :
        minWidth;
      
      return `${width}px`;
    },
    isReadOnly() {
      return false;
    }
  },
  async created() {
    await this.loadCategorias();
    await this.loadEstados();
    // Leer rol y user_id de sesión si existen
    try {
      const storedRole = sessionStorage.getItem('user_role');
      this.userRole = storedRole != null ? Number(storedRole) : null;
      const storedUserId = sessionStorage.getItem('user_id');
      this.form.usuario_id = storedUserId != null ? Number(storedUserId) : this.form.usuario_id;
    } catch (e) {
      this.userRole = null;
    }

    await this.loadUsers();
    // Asegurar que la descripción inicial no supere el tope
    if (this.form.descripcion && this.form.descripcion.length > this.maxDescripcion) {
      this.form.descripcion = this.form.descripcion.slice(0, this.maxDescripcion);
    }
  },
  mounted() {
    this._escHandler = (e) => { if (e.key === 'Escape') this.$emit('close'); };
    window.addEventListener('keydown', this._escHandler);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this._escHandler);
    // Limpiar URLs temporales
    if (this.previewObjectUrl) {
      try { URL.revokeObjectURL(this.previewObjectUrl); } catch(e) { /* noop */ }
    }
  },
  methods: {
    cerrar() { this.$emit('close'); },
    
    getCategoriaTraducida(nombreCategoria) {
      const mapeo = {
        "Hardware": "hardware",
        "Software": "software",
        "Redes y conectividad": "redes",
        "Correo Electronico": "correo",
        "Accesos y contraseñas": "acceso",
        "Impresion y escaneo": "impresion",
        "Seguridad": "seguridad",
        "Telefonia": "telefonia",
        "Aplicaciones Web / Intranet": "web",
        "Otros": "otros"
      };
      const clave = mapeo[nombreCategoria];
      if (clave && this.$t(`categorias_traducidas.${clave}`) !== `categorias_traducidas.${clave}`) {
        return this.$t(`categorias_traducidas.${clave}`);
      }
      return nombreCategoria;
    },
    
    async loadCategorias() {
      try {
        console.log('Cargando categor\u00edas...');
        const token = sessionStorage.getItem('auth_token');
        if (!token) {
          console.error('No hay token de autenticaci\u00f3n');
          return;
        }
        
        const response = await api.get('/tickets/categorias', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        this.categorias = response.data.categorias ?? response.data ?? [];
        console.log('Categor\u00edas cargadas:', this.categorias.length);
      } catch (error) {
        console.error('Error cargando categor\u00edas:', error);
        await showAlert('error', this.$t('error_cargar_categorias') || 'Error', '', { 
          html: this.$t('error_cargar_categorias') || 'Error cargando categor\u00edas' 
        });
      }
    },
    
    async loadEstados() {
      try {
        console.log('Cargando estados...');
        const token = sessionStorage.getItem('auth_token');
        if (!token) {
          console.error('No hay token de autenticaci\u00f3n');
          return;
        }
        
        const response = await api.get('/tickets/estados', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        this.estados = response.data.estados ?? response.data ?? [];
        console.log('Estados cargados:', this.estados.length);
      } catch (error) {
        console.error('Error cargando estados:', error);
        await showAlert('error', this.$t('error_cargar_estados') || 'Error', '', { 
          html: this.$t('error_cargar_estados') || 'Error cargando estados' 
        });
      }
    },

    async loadUsers() {
      try {
        console.log('Cargando usuarios...');
        const token = sessionStorage.getItem('auth_token');
        if (!token) {
          console.error('No hay token de autenticación para cargar usuarios');
          return;
        }

        const response = await api.get('/users/reduced-fields', {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        // Esperamos { data: [ { usuario_id, nombre_completo, delegacion_id, departamento_id }, ... ] }
        const raw = response.data;
        const list = Array.isArray(raw.data) ? raw.data : [];

        this.users = list
          .map(u => ({
            id: u.usuario_id ?? u.id,
            nombre: u.nombre_completo ?? ((u.nombre || '') + ' ' + (u.apellidos || '')).trim(),
            delegacion_id: u.delegacion_id ?? null,
            departamento_id: u.departamento_id ?? null
          }))
          .filter(u => u.id != null);

        console.log('Usuarios cargados:', this.users.length);
      } catch (err) {
        console.error('Error cargando usuarios:', err, err.response?.data);
        // No mostrar alerta crítico aquí; el select es opcional
        this.users = [];
      }
    },
    
    addFiles(event) {
      const nuevos = Array.from(event.target.files || []);
      const MAX_BYTES = 15 * 1024 * 1024; // 15 MB
      const tooBig = nuevos.filter(f => f && f.size > MAX_BYTES);
      
      if (tooBig.length) {
        const names = tooBig.map(f => f.name).join(', ');
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          html: `Los siguientes archivos superan el límite de 15MB:<br><strong>${names}</strong>`,
          confirmButtonText: 'Aceptar'
        });
      }
      
      const acceptedBySize = nuevos.filter(f => f && f.size <= MAX_BYTES);
      const processed = acceptedBySize.map(f => this.sanitizeFileObj(f));
      
      const archivosValidos = processed.filter(file =>
        file.type === 'application/pdf' ||
        file.type?.startsWith?.('image/') ||
        /\.(pdf|jpg|jpeg|png|gif|webp|bmp|heic|heif)$/i.test(file.name)
      );
      
      if (archivosValidos.length < processed.length) {
        Swal.fire({
          icon: 'error',
          title: this.$t('solo_imagenes_pdf') || 'Solo PDF/imagen',
          html: this.$t('solo_imagenes_pdf') || 'Solo se permiten PDF o imágenes',
          confirmButtonText: 'Aceptar'
        });
      }
      
      this.selectedFiles = [...this.selectedFiles, ...archivosValidos];
      event.target.value = "";
    },
    
    removeFile(idx) {
      this.selectedFiles.splice(idx, 1);
    },

    onDescripcionInput(e) {
      if (!this.form.descripcion) return;
      if (this.form.descripcion.length > this.maxDescripcion) {
        this.form.descripcion = this.form.descripcion.slice(0, this.maxDescripcion);
      }
    },
    
    async uploadFiles(ticketId) {
      try {
        console.log('=== INICIANDO SUBIDA DE ARCHIVOS ===');
        console.log('Ticket ID:', ticketId);
        console.log('Número de archivos:', this.selectedFiles.length);
        
  const token = sessionStorage.getItem('auth_token');
        if (!token) {
          throw new Error('No hay token de autenticación disponible');
        }
        
        for (const [index, file] of this.selectedFiles.entries()) {
          console.log(`Subiendo archivo ${index + 1}/${this.selectedFiles.length}:`, {
            nombre: file.name,
            tamaño: `${(file.size / 1024 / 1024).toFixed(2)} MB`,
            tipo: file.type,
            comentario: file.comentario || '(sin comentario)'
          });

          const formData = new FormData();
          
          // Usar el nombre original o sanitizado
          const safeName = this.sanitizeFileName(file.name || 'archivo');
          formData.append('file', file, safeName);
          
          // Solo añadir comentario si existe y no está vacío
          if (file.comentario && file.comentario.trim() !== '') {
            formData.append('comentario', file.comentario.trim());
          }

          // DEBUG: Ver contenido del FormData
          console.log('Contenido del FormData:');
          for (let [key, value] of formData.entries()) {
            console.log(`  ${key}:`, value instanceof File ? 
              `File(${value.name}, ${value.size} bytes, ${value.type})` : 
              `"${value}"`);
          }

          // CONFIGURACIÓN CON HEADERS DE AUTORIZACIÓN
          const config = {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (e) => {
              if (e.lengthComputable) {
                const progress = Math.round((e.loaded * 100) / e.total);
                this.uploadProgress = progress;
                console.log(`Progreso de ${file.name}: ${progress}%`);
              }
            }
          };

          console.log('Enviando petición POST a:', `/tickets/${ticketId}/upload-file`);
          
          try {
            const response = await api.post(`/tickets/${ticketId}/upload-file`, formData, config);
            console.log(`✅ Archivo "${file.name}" subido exitosamente`);
            console.log('Respuesta del servidor:', response.data);
          } catch (uploadError) {
            console.error(`❌ Error subiendo archivo "${file.name}":`, uploadError);
            console.error('Status:', uploadError.response?.status);
            console.error('Datos:', uploadError.response?.data);
            console.error('Headers:', uploadError.response?.headers);
            
            let errorMessage = `Error subiendo archivo "${file.name}"`;
            
            if (uploadError.response?.data) {
              const serverError = uploadError.response.data;
              console.error('Error del servidor:', serverError);
              
              if (serverError.message) {
                errorMessage = serverError.message;
              } else if (serverError.errors) {
                errorMessage = Object.values(serverError.errors).flat().join(', ');
              }
            }
            
            await showAlert('error', 'Error al subir archivo', '', {
              html: `<strong>Error:</strong><br>${errorMessage}`
            });
            
            throw uploadError;
          }
        }

        console.log('✅ Todos los archivos subidos exitosamente');
        this.selectedFiles = [];
        
        // Recargar archivos del ticket
        await this.fetchTicketFiles(ticketId);
        
      } catch (err) {
        console.error('❌ Error general en uploadFiles:', err);
        
        const errorMessage = err.message || 'Error de red al subir archivos';
        await showAlert('error', 'Error', '', { 
          html: `<strong>Error al subir archivos:</strong><br>${errorMessage}` 
        });
        
        throw err;
      } finally {
        this.uploadProgress = 0;
      }
    },
    
    async fetchTicketFiles(ticketId) {
      try {
        console.log(`Cargando archivos para ticket ${ticketId}...`);
        
  const token = sessionStorage.getItem('auth_token');
        if (!token) {
          console.error('No hay token de autenticación');
          return;
        }
        
        const response = await api.get(`/tickets/${ticketId}/files`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        console.log('Archivos cargados:', response.data.files?.length || 0);
        this.ticketFiles = response.data.files || [];
      } catch (err) {
        console.error('Error al cargar archivos:', err);
        console.error('Response:', err.response);
        
        const payload = err.response?.data || { message: err.message || 'Network error' };
        const msg = payload.message || 'Error cargando archivos';
        
        await showAlert('error', 'Error', '', { 
          html: `<strong>Error al cargar archivos:</strong><br>${msg}` 
        });
        
        this.ticketFiles = [];
      }
    },
    
    async handleSubmit(event) {
      const formEl = event?.currentTarget || (event?.target && event.target.form) || null;
      const submitBtn = formEl ? formEl.querySelector('button[type="submit"]') : null;

      if (this._submitting) return;
      this._submitting = true;
      this.isSaving = true;
      this.uploadProgress = 0;

      if (submitBtn) submitBtn.disabled = true;
      
      console.log('=== INICIANDO CREACIÓN DE TICKET ===');
      
      try {
        // Verificar token
  const token = sessionStorage.getItem('auth_token');
        if (!token) {
          throw new Error('No hay token de autenticación. Por favor, inicie sesión nuevamente.');
        }
        
        console.log('Token disponible: SÍ');

        // 1. Obtener perfil del usuario
        console.log('1. Obteniendo perfil del usuario...');
        const perfilResponse = await api.get('/users/perfil', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const usuarioLogueado = perfilResponse.data.user;
        console.log('Usuario logueado:', usuarioLogueado);
        // Asegurar que el campo usuario_id por defecto coincide con el usuario logueado
        try {
          const loggedId = usuarioLogueado?.id || usuarioLogueado?.user_id || null;
          if ((this.form.usuario_id == null || this.form.usuario_id === '') && loggedId != null) {
            this.form.usuario_id = Number(loggedId);
          }
        } catch (e) {
          // noop
        }
        
        // Obtener delegacion/departamento del usuario logueado por defecto
        let delegacionId = parseInt(usuarioLogueado.delegacion_id, 10);
        let departamentoId = parseInt(usuarioLogueado.departamento_id, 10);

        // Detectar si el usuario logueado es operador (rol 4)
        const loggedRole = usuarioLogueado?.rol_id != null ? Number(usuarioLogueado.rol_id) : (this.userRole != null ? Number(this.userRole) : null);
        const isOperador = loggedRole === 4;

        // Si NO es operador y se ha seleccionado explícitamente un usuario en el select,
        // usar la delegación/departamento de ese usuario seleccionado (si están disponibles).
        if (!isOperador && this.form.usuario_id != null) {
          try {
            const sel = this.users.find(u => Number(u.id) === Number(this.form.usuario_id));
            if (sel) {
              const selDeleg = sel.delegacion_id != null ? parseInt(sel.delegacion_id, 10) : NaN;
              const selDept = sel.departamento_id != null ? parseInt(sel.departamento_id, 10) : NaN;
              if (!isNaN(selDeleg)) delegacionId = selDeleg;
              if (!isNaN(selDept)) departamentoId = selDept;
            }
          } catch (e) {
            // noop - si algo falla, mantenemos las IDs del usuario logueado
            console.warn('No se pudo obtener delegacion/departamento del usuario seleccionado:', e);
          }
        }

        // Si es operador, forzar usuario_id y los datos de delegacion/departamento al usuario logueado
        if (isOperador) {
          const loggedId = usuarioLogueado?.id || usuarioLogueado?.user_id || null;
          if (loggedId != null) {
            this.form.usuario_id = Number(loggedId);
          }
          // Asegurarse de que delegacion/departamento son válidos
          if (isNaN(delegacionId) || isNaN(departamentoId)) {
            throw new Error('delegacion_id o departamento_id del usuario logueado no son válidos.');
          }
        } else {
          if (isNaN(delegacionId) || isNaN(departamentoId)) {
            throw new Error('delegacion_id o departamento_id no son válidos.');
          }
        }

        console.log('2. IDs obtenidos - delegacion:', delegacionId, 'departamento:', departamentoId, 'isOperador:', isOperador);

        // 2. Preparar payload
        const categoriaSeleccionada = this.categorias.find(cat => cat.id === Number(this.form.categoria));
        // Valor por defecto desde la categoría (si la categoría define un usuario de notificación)
        const usuarioAsignadoIdFromCategory = categoriaSeleccionada && categoriaSeleccionada.id_user_notification
          ? categoriaSeleccionada.id_user_notification
          : null;

        // Si el formulario incluye explícitamente un usuario asignado, darle prioridad
        const usuarioAsignadoId = (this.form.usuario_asignado_id || this.form.usuario_asignado_id === 0)
          ? Number(this.form.usuario_asignado_id)
          : usuarioAsignadoIdFromCategory;

        const payload = {
          delegacion_id: delegacionId,
          departamento_id: departamentoId,
          categoria_id: this.form.categoria,
          prioridad_id: this.form.prioridad,
          estado_id: 1,
          descripcion: this.form.descripcion,
          usuario_asignado_id: usuarioAsignadoId || null,
          // El propietario del ticket (usuario que tiene la incidencia). Por defecto coincide con el usuario logueado.
          usuario_id: this.form.usuario_id != null ? Number(this.form.usuario_id) : null,
        };
        
        console.log('3. Payload para crear ticket:', payload);

        // 3. Crear ticket con headers
        console.log('4. Creando ticket...');
        const response = await api.post('/tickets', payload, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        const ticketCreado = response.data.ticket;
        console.log('5. Ticket creado:', ticketCreado);

        // 4. Subir archivos si hay
        if (this.selectedFiles.length) {
          console.log(`6. Subiendo ${this.selectedFiles.length} archivos...`);
          await this.uploadFiles(ticketCreado.id);
        } else {
          console.log('6. No hay archivos para subir');
        }

        // 5. Mostrar mensaje de éxito
        const title = this.$t ? this.$t('ticket_creado_exitosamente') : 'Ticket creado';
        const translated = this.$t ? this.$t('ticket_creado_text', { id: ticketCreado.id }) : null;
        const htmlMessage = translated && typeof translated === 'string' && translated.includes(String(ticketCreado.id))
          ? translated
          : `Ticket creado con ID ${ticketCreado.id}.`;
        
        await Swal.fire({
          icon: 'success',
          title,
          html: htmlMessage,
          target: 'body',
          position: 'center',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        });
        
        console.log('7. Operación completada con éxito');
        // Dispatch a global event so other views (e.g. WelcomeView) can react and reload lists
        try {
          window.dispatchEvent(new CustomEvent('ticketCreated', { detail: ticketCreado }));
        } catch (e) {
          // ignore if dispatching fails in some environments
          console.warn('No se pudo despachar evento global ticketCreated', e);
        }
        this.$emit('submit', ticketCreado);
        this.$emit('close');
        
      } catch (error) {
        console.error('=== ERROR EN CREACIÓN DE TICKET ===');
        console.error('Error completo:', error);
        console.error('Error response:', error.response);
        
        let errorMsg = error.response?.data?.message || error.message;
        if (error.response?.data?.errors) {
          errorMsg += '\n' + JSON.stringify(error.response.data.errors);
        }
        
        await showAlert('error', this.$t('error_crear_ticket') || 'Error', '', { 
          html: `<strong>Error creando ticket:</strong><br>${errorMsg}` 
        });
      } finally {
        this._submitting = false;
        if (submitBtn) submitBtn.disabled = false;
        setTimeout(() => {
          this.isSaving = false;
          this.uploadProgress = 0;
        }, 150);
      }
    },
    
    // Método para previsualizar archivos
    async previewFile(file) {
      console.log('[previewFile] called with:', file);
      
      // Limpiar preview anterior
      if (this.previewObjectUrl) {
        try { 
          URL.revokeObjectURL(this.previewObjectUrl); 
        } catch(e) { /* ignore */ }
        this.previewObjectUrl = '';
      }
      
      // Si es un archivo File (local)
      if (file instanceof File) {
        try {
          const url = URL.createObjectURL(file);
          this.previewObjectUrl = url;
          // Estructura que PreviewModal espera
          this.previewFileObj = {
            file: file,
            name: file.name,
            type: file.type
          };
          this.previewVisible = true;
          document.body.classList.add('preview-open');
          return;
        } catch (e) {
          console.error('Error creating objectURL:', e);
          await showAlert('error', 'Error', '', { html: 'No se pudo previsualizar el archivo' });
          return;
        }
      }
      
      // Si es un archivo remoto (con id)
      if (file && file.id) {
        try {
          const token = sessionStorage.getItem('auth_token');
          const response = await api.get(`/tickets/files/download/${file.id}`, {
            responseType: 'blob',
            headers: { 
              'Authorization': `Bearer ${token}` 
            }
          });
          const blob = response.data;
          const url = URL.createObjectURL(blob);
          this.previewObjectUrl = url;
          this.previewFileObj = {
            id: file.id,
            filename: file.filename || file.name || 'archivo',
            type: blob.type
          };
          this.previewVisible = true;
          document.body.classList.add('preview-open');
        } catch (err) {
          console.error('Error descargando archivo para preview:', err, err.response?.data);
          await showAlert('error', 'Error', '', { html: 'No se pudo previsualizar el archivo' });
        }
        return;
      }
      
      // Si no es un tipo válido
      await showAlert('error', 'Error', '', { html: 'No se puede previsualizar este archivo' });
    },
    
    closePreview() {
      if (this.previewObjectUrl) {
        try { 
          URL.revokeObjectURL(this.previewObjectUrl); 
        } catch(e) { /* ignore */ }
      }
      this.previewObjectUrl = '';
      this.previewFileObj = null;
      this.previewVisible = false;
      document.body.classList.remove('preview-open');
    },
    
    // Método para manejar la descarga desde PreviewModal
    handlePreviewDownload(payload) {
      const file = payload?.file || payload || this.previewFileObj;
      if (file) {
        this.downloadFile(file);
      }
    },
    
    downloadFile(file) {
      if (file instanceof File) {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else if (file.file_url || file.url) {
        const a = document.createElement('a');
        a.href = file.file_url || file.url;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        showAlert('error', this.$t('no_previsualizar_archivo') || 'No disponible', '', { 
          html: this.$t('no_previsualizar_archivo') || 'No se puede previsualizar el archivo' 
        });
      }
    },
    
    // Métodos para renombrar archivos
    startRename(idx) {
      this.renameIndex = idx;
      this.renameBase = this.getBaseName(this.selectedFiles[idx].name);
    },
    
    confirmRename(idx) {
      if (this.renameBase.trim() === '') {
        this.showToast && this.showToast(this.$t('nombre_obligatorio'), "error");
        return;
      }
      
      const oldFile = this.selectedFiles[idx];
      const ext = this.getExtension(oldFile.name);
      const newNameRaw = ext ? `${this.renameBase}.${ext}` : this.renameBase;
      const newName = this.sanitizeFileName(newNameRaw);
      
      try {
        const renamedFile = new File([oldFile], newName, { 
          type: oldFile.type, 
          lastModified: oldFile.lastModified 
        });
        renamedFile.comentario = oldFile.comentario;
        this.selectedFiles.splice(idx, 1, renamedFile);
      } catch (e) {
        oldFile.name = newName;
        this.selectedFiles.splice(idx, 1, oldFile);
      }
      
      this.renameIndex = null;
      this.renameBase = '';
    },
    
    cancelRenameEdit() {
      this.renameIndex = null;
      this.renameBase = '';
    },
    
    getBaseName(filename) {
      const lastDot = filename.lastIndexOf('.');
      return lastDot === -1 ? filename : filename.substring(0, lastDot);
    },
    
    getExtension(filename) {
      const lastDot = filename.lastIndexOf('.');
      return lastDot === -1 ? '' : filename.substring(lastDot + 1);
    },
    
    // Métodos para comentarios
    toggleComment(idx) {
      if (this.commentIndex === idx) {
        this.commentIndex = null;
        this.commentValue = '';
      } else {
        this.commentIndex = idx;
        this.commentValue = this.selectedFiles[idx].comentario || '';
      }
    },
    
    confirmComment(idx) {
      const file = this.selectedFiles[idx];
      file.comentario = this.commentValue.trim() === '' ? '' : this.commentValue;
      this.commentIndex = null;
      this.commentValue = '';
    },
    
    cancelCommentEdit() {
      this.commentIndex = null;
      this.commentValue = '';
    },
    
    getDownloadUrl(fileId) {
  const token = sessionStorage.getItem('auth_token');
      return `/api/tickets/files/download/${fileId}?token=${token}`;
    },
    
    // Métodos para sanitizar nombres de archivos
    sanitizeFileName(filename = '') {
      const MAX_TOTAL = 25;
      const MAX_EXT = 12;
      const lastDot = filename.lastIndexOf('.');
      let base = lastDot === -1 ? filename : filename.substring(0, lastDot);
      let ext = lastDot === -1 ? '' : filename.substring(lastDot + 1);
      
      base = base.replace(/[^a-zA-Z0-9-_\.]/g, '_').replace(/_+/g, '_');
      ext = ext.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      
      if (ext.length > MAX_EXT) ext = ext.substring(0, MAX_EXT);
      const remaining = ext ? MAX_TOTAL - (ext.length + 1) : MAX_TOTAL;
      
      if (base.length > remaining) base = base.substring(0, remaining);
      const result = ext ? `${base}.${ext}` : base;
      
      return result || 'file';
    },
    
    sanitizeFileObj(file) {
      if (!file) return file;
      const safeName = this.sanitizeFileName(file.name || 'file');
      
      if (safeName === file.name) return file;
      
      try {
        const newFile = new File([file], safeName, { 
          type: file.type, 
          lastModified: file.lastModified 
        });
        if (file.comentario) newFile.comentario = file.comentario;
        return newFile;
      } catch (e) {
        file.name = safeName;
        return file;
      }
    },
    
    showToast(message, type = 'info') {
      // Implementación de toast aquí
      console.log(`${type}: ${message}`);
    }
  }
};
</script>

<style scoped>
.modal-content {
  background-color: white;
  border-radius: 8px;
  min-width: 40vw;
  max-width: 95vw;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  margin: 20px auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #99172A;
  color: white;
  padding: 15px 20px;
  left: 0px;
  top: 0px;
}

.modal-title {
  margin-left: 12px;
}

.modal-header .btn-close {
  margin-right: 12px;
}

.modal-title {
  margin: 0;
  font-size: 1.5rem;
}

.btn-close {
  filter: none;
  opacity: 0.95;
  color: #fff;
}

.btn-close .material-icons {
  color: #fff !important;
}

.btn-close:hover {
  opacity: 1;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
}

.form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.btn-primary {
  background-color: #99172A;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #7A1222;
}

.btn-primary[disabled],
.btn-primary:disabled {
  background-color: #99172A !important;
  color: #fff !important;
  opacity: 0.8;
  cursor: not-allowed;
  pointer-events: none;
  box-shadow: none !important;
}

.btn-cancel {
  background-color: #6c757d;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 44px;
  line-height: 24px;
  display: inline-block;
  vertical-align: middle;
}

.btn-cancel:hover {
  background-color: #495057;
}

.adjuntos-scroll {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  background-color: #f8f9fa;
}

.btn-elegir-archivo {
  background-color: #6c757d;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 6px 10px;
  font-size: 0.95rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 40px;
  line-height: 1;
  min-width: 0;
  width: 140px;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-elegir-archivo:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-elegir-archivo:hover:not(:disabled) {
  background-color: #495057;
}

.btn-preview {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  width: 36px;
  height: 36px;
  border-radius: 4px;
}

.btn-preview .material-icons {
  font-size: 18px;
  color: #6c757d;
}

.debug-modal-backdrop {
  pointer-events: auto;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483646;
}

.debug-modal-backdrop .modal-content { 
  pointer-events: auto; 
  z-index: 2147483647; 
}
</style>